import { useQuery } from "@tanstack/react-query";

import auditLogsApi from "./api";
import { AUDIT_LOGS_QUERY_KEY } from "./constants";

export const useFetchAuditLogs = ({ params, options = {} }) =>
  useQuery({
    queryKey: [AUDIT_LOGS_QUERY_KEY, params],
    queryFn: () => auditLogsApi.fetchAuditLogs(params),
    ...options,
  });
